function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.04166 9.29165V5.4458C5.27787 5.19487 6.20832 4.10192 6.20832 2.79165C6.20832 1.29588 4.99576 0.083313 3.49999 0.083313C2.00422 0.083313 0.791656 1.29588 0.791656 2.79165C0.791656 4.10192 1.72211 5.19487 2.95832 5.4458V9.29165H4.04166ZM5.12499 2.79165C5.12499 3.68911 4.39745 4.41665 3.49999 4.41665C2.60253 4.41665 1.87499 3.68911 1.87499 2.79165C1.87499 1.89418 2.60253 1.16665 3.49999 1.16665C4.39745 1.16665 5.12499 1.89418 5.12499 2.79165Z",
  fill: "#3C3C3C"
});

var SvgIconPin = function SvgIconPin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 10,
    viewBox: "0 0 7 10",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconPin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-pin.d1f98ce2.svg";
export { ForwardRef as ReactComponent };